import { gql } from 'apollo-boost';

export const CHEF_BOOKINGS = gql`
    query chefBookings($chefId: ID!, $status: BOOKING_STATE!, $pageSize: Int, $bookingCount: Int, $next: String, $previous: String, $startDate: Date, $numWeeks: Int) {
        chefBookings(chefId: $chefId, status: $status, pageSize: $pageSize, next: $next, previous: $previous, startDate: $startDate, numWeeks: $numWeeks, bookingCount: $bookingCount) {
            bookings {
                id
                userId
                chefId
                userName
                chefName
                distance
                displayId
                proposalMade
                proposedBy
                proposalComments
                counterProposals {
                    proposedDate
                    proposedTime
                    proposedTimeEnd
                    proposedAmount
                    proposedBy
                    proposalComments
                    createdAt
                }
                amount
                date
                isProposalRead
                timeSlot {
                    start
                    end
                }
                dishes {
                    dishId
                    dishName
                    serves
                    price
                }
                message
                cancellationPolicy { allowCancellation timeBeforeCancellation timeBeforeCancellationMetric penaltyCharge penaltyChargeMetric comments }
                equipmentsPresent
                equipmentsAbsent
                status
                isCustom
                isRecurring
                dinerSize
                startPrice
                endPrice
                proposedDate
                proposedTime
                proposedTimeEnd
                proposedAmount
                rejectReason
                chefReviewId
                userReviewId
                serviceCharges
                transactionFee
                transactionFeeCharges
                isRefund
                refundAmount
                chefTransferAmount
                chefChargedForCancellation
                address {
                    street1
                    street2
                    city
                    state
                    zip
                }
            }
        }
    }
`;

export const USER_BOOKINGS = gql`
    query userBookings(
        $userId: ID!
        $status: BOOKING_STATE
        $cursor: String
        $pageSize: Int
        $next: String
        $previous: String
    ) {
        userBookings(
            userId: $userId
            status: $status
            cursor: $cursor
            pageSize: $pageSize
            next: $next
            previous: $previous
        ) {
            bookings {
                id
                userId
                chefId
                userName
                chefName
                distance
                displayId
                isCustom
                isRecurring
                isProposalRead
                dinerSize
                startPrice
                endPrice
                proposedDate
                proposedTime
                proposedTimeEnd
                proposedAmount
                proposalMade
                proposedBy
                proposalComments
                counterProposals {
                    proposedDate
                    proposedTime
                    proposedTimeEnd
                    proposedAmount
                    proposedBy
                    proposalComments
                    createdAt
                }
                amount
                date
                timeSlot {
                    start
                    end
                }
                dishes {
                    dishId
                    dishName
                    serves
                    price
                }
                message
                cancellationPolicy { allowCancellation timeBeforeCancellation timeBeforeCancellationMetric penaltyCharge penaltyChargeMetric comments }
                equipmentsPresent
                equipmentsAbsent
                status
                rejectReason
                chefReviewId
                userReviewId
                serviceCharges
                transactionFee
                transactionFeeCharges
                isRefund
                refundAmount
                chefTransferAmount
                chefChargedForCancellation
                address {
                    street1
                    street2
                    city
                    state
                    zip
                }
            }
        }
    }
`;

export const BOOKING_TRANSACTION = gql`
    query fetchTransactionFeeForBooking($id: ID!) {
        fetchTransactionFeeForBooking(id: $id) {
            couponCode
            planName
            planPrice
            transactionFee
        }
    }
`;

export const BOOKING_DETAILS = gql`
    query bookingDetails($id: ID!) {
        bookingDetails(id: $id) {
            id
            userId
            chefId
            userName
            chefName
            distance
            displayId
            isCustom
            isRecurring
            isProposalRead
            dinerSize
            startPrice
            endPrice
            proposedDate
            proposedTime
            proposedTimeEnd
            proposedAmount
            proposalMade
            proposedBy
            transactionFeeCharges
            proposalComments
            counterProposals {
                proposedDate
                proposedTime
                proposedTimeEnd
                proposedAmount
                proposedBy
                proposalComments
                createdAt
            }
            amount
            date
            timeSlot {
                start
                end
            }
            dishes {
                dishId
                dishName
                serves
                price
            }
            message
            cancellationPolicy { allowCancellation timeBeforeCancellation timeBeforeCancellationMetric penaltyCharge penaltyChargeMetric comments }
            equipmentsPresent
            equipmentsAbsent
            status
            rejectReason
            chefReviewId
            userReviewId
            serviceCharges
            transactionFee
            isRefund
            refundAmount
            chefTransferAmount
            chefChargedForCancellation
            address {
                street1
                street2
                city
                state
                zip
            }
        }
    }
`;

export const BOOKING_BY_TOKEN = gql`
  query fetchBookingByToken($token: String!) {
    fetchBookingByToken(token: $token) {
      id
      userId
      chefId
      userName
      chefName
      distance
      displayId
      isCustom
      isRecurring
      isProposalRead
      dinerSize
      startPrice
      endPrice
      proposedDate
      proposedTime
      proposedTimeEnd
      proposedAmount
      proposalMade
      proposedBy
      proposalComments
      counterProposals {
        proposedDate
        proposedTime
        proposedTimeEnd
        proposedAmount
        proposedBy
        proposalComments
        createdAt
      }
      amount
      date
      timeSlot {
        start
        end
      }
      dishes {
        dishId
        dishName
        serves
        price
      }
      message
      cancellationPolicy { allowCancellation timeBeforeCancellation timeBeforeCancellationMetric penaltyCharge penaltyChargeMetric comments }
      equipmentsPresent
      equipmentsAbsent
      status
      rejectReason
      chefReviewId
      userReviewId
      serviceCharges
      transactionFee
      transactionFeeCharges
      isRefund
      refundAmount
      chefTransferAmount
      chefChargedForCancellation
      address {
        street1
        street2
        city
        state
        zip
      }
    }
  }
`;
